module.exports = __webpack_public_path__ + "static/media/sombra-miolo-debru.3a36dd05.svg";